import type { TranslateService } from '@ngx-translate/core';

/** The app's text for an i18n key, or the key itself when the app has no entry for it. */
export function translated(
    translate: TranslateService,
    key: string,
    params?: Readonly<Record<string, unknown>>
): string {
    const text: unknown = translate.instant(key, params);
    return typeof text === 'string' ? text : key;
}
